import { Navigate, Outlet } from 'react-router-dom';
import { getItemWithExpiration } from './utils';

/**
 * SuperAdmin 전용 라우트 가드
 * - authorization 토큰 존재 확인
 * - authObject.role === 'superadmin' 확인
 * - 구독 상태 체크 없음 (폐쇄형 시스템)
 */
const SuperAdminPrivateRoutes = () => {
    const authorization = getItemWithExpiration('authorization');
    const authObject = getItemWithExpiration('authObject');

    if (!authorization || !authObject) {
        return <Navigate to="/signIn" replace />;
    }

    if (authObject.role !== 'superadmin') {
        return <Navigate to="/signIn" replace />;
    }

    return <Outlet />;
};

export default SuperAdminPrivateRoutes;
